import axiosInstance from '@core/utils/axiosInstance';
import { ProductionStage } from '../src/enum/productionStage';
import type { Color } from './color';
import type {
  AlbItem,
  ChasubleItem,
  MitreItem,
  Order,
  StoleItem,
} from './order';

type ProductionOrderItem = ChasubleItem | AlbItem | StoleItem | MitreItem;

export type ProductionItem = Pick<
  ProductionOrderItem,
  | 'id'
  | 'vestment'
  | 'design'
  | 'quantity'
  | 'sizeMode'
  | 'size'
  | 'forCustomer'
  | 'notes'
  | 'printQueuedAt'
> & {
  bodyColor?: Color | null;
  panelColor?: Color | null;
  productionStage: ProductionStage;
  productionSummary: string | null;
  order: Pick<Order, 'id' | 'customer' | 'status'>;
};

export const getProductionItems = async (): Promise<ProductionItem[]> => {
  const { data } = await axiosInstance.get<ProductionItem[]>('/production');
  return data;
};

export const updateProductionItemStage = async (
  id: number,
  productionStage: ProductionStage
): Promise<ProductionItem> => {
  const { data } = await axiosInstance.put<ProductionItem>(
    `/production/${id}/stage`,
    { productionStage }
  );
  return data;
};

export const confirmProductionPrint = async (
  itemIds: number[]
): Promise<void> => {
  await axiosInstance.post('/production/confirm-print', { itemIds });
};

export type PrintHistoryBatch = {
  batchId: string;
  itemIds: number[];
  printedAt: string;
  printedBy: {
    id: number;
    firstName: string | null;
    lastName: string | null;
  } | null;
};

export const getPrintHistory = async (): Promise<PrintHistoryBatch[]> => {
  const { data } = await axiosInstance.get<PrintHistoryBatch[]>(
    '/production/print-history'
  );
  return data;
};

export const confirmProductionReprint = async (
  itemIds: number[]
): Promise<void> => {
  await axiosInstance.post('/production/confirm-reprint', { itemIds });
};
